import { Divider } from "@mui/material";
import {
  legalPermissionStatusEnum,
  legalPermissionTypeEnum,
} from "../../../../utils";
import { FC } from "react";
import useLocales from "../../../../hooks/useLocales";

type ILegalPermissionStatus = {
  legalPermission: any[];
};

const LegalPermissionStatus: FC<ILegalPermissionStatus> = ({
  legalPermission,
}) => {
  const { translate } = useLocales();

  const getKvkkDurum = (permission: any) => {
    if (
      permission?.legalPermissionStatusId === legalPermissionStatusEnum.approved
    ) {
      return (
        <span style={{ color: "green" }}>
          {translate("resources.customers.related_persons.kvkkApproved")}
        </span>
      );
    } else if (
      permission?.legalPermissionStatusId === legalPermissionStatusEnum.waiting
    ) {
      return (
        <span style={{ color: "#b5b51e" }}>
          {translate("resources.customers.related_persons.kvkkWaiting")}
        </span>
      );
    } else if (
      permission?.legalPermissionStatusId === legalPermissionStatusEnum.denied
    ) {
      return (
        <span style={{ color: "red" }}>
          {translate("resources.customers.related_persons.kvkkDenied")}
        </span>
      );
    } else {
      return (
        <span style={{ color: "orange" }}>
          {translate("resources.customers.related_persons.kvkkUnknown")}
        </span>
      );
    }
  };

  // const getIYSDurum = (permissions: any) => {
  //   let color = "green";
  //   if (permissions.length === 0) {
  //     return (
  //       <span style={{ color: "orange" }}>
  //         {translate("resources.customers.related_persons.iysUnknown")}
  //       </span>
  //     );
  //   } else {
  //     let mailPermission = null;
  //     let smsPermission = null;
  //     mailPermission = permissions.find(
  //       (f: any) => f.channelId === legalPermissionChanelEnum.email
  //     );
  //     smsPermission = permissions.find(
  //       (f: any) => f.channelId === legalPermissionChanelEnum.sms
  //     );
  //     let str = "";
  //     if (mailPermission) {
  //       if (
  //         mailPermission.legalPermissionStatusId ===
  //         legalPermissionStatusEnum.approved
  //       ) {
  //         str += `${translate(
  //           "resources.customers.related_persons.iysMailApproved"
  //         )} `;
  //         color = "green";
  //       } else if (
  //         mailPermission.legalPermissionStatusId ===
  //         legalPermissionStatusEnum.waiting
  //       ) {
  //         str += `${translate(
  //           "resources.customers.related_persons.iysMailWaiting"
  //         )} `;
  //         color = "#b5b51e";
  //       } else if (
  //         mailPermission.legalPermissionStatusId ===
  //         legalPermissionStatusEnum.waiting
  //       ) {
  //         str += `${translate(
  //           "resources.customers.related_persons.iysMailDenied"
  //         )} `;
  //         color = "red";
  //       }
  //     } else {
  //       str += `${translate(
  //         "resources.customers.related_persons.iysMailUnknown"
  //       )} `;
  //       color = "orange";
  //     }

  //     if (smsPermission) {
  //       if (
  //         smsPermission.legalPermissionStatusId ===
  //         legalPermissionStatusEnum.approved
  //       ) {
  //         str += `${translate(
  //           "resources.customers.related_persons.iysSmsApproved"
  //         )} `;
  //         color = "green";
  //       } else if (
  //         smsPermission.legalPermissionStatusId ===
  //         legalPermissionStatusEnum.waiting
  //       ) {
  //         str += `${translate(
  //           "resources.customers.related_persons.iysSmsWaiting"
  //         )} `;
  //         color = "#b5b51e";
  //       } else if (
  //         smsPermission.legalPermissionStatusId ===
  //         legalPermissionStatusEnum.denied
  //       ) {
  //         str += `${translate(
  //           "resources.customers.related_persons.iysSmsDenied"
  //         )} `;
  //         color = "red";
  //       }
  //     } else {
  //       str += `${translate(
  //         "resources.customers.related_persons.iysSmsUnknown"
  //       )} `;
  //       color = "orange";
  //     }
  //     return (
  //       <>
  //         <span style={{ color: color }}>{str}</span>
  //       </>
  //     );
  //   }

  //   // if (
  //   //   permission?.legalPermissionStatusId === legalPermissionStatusEnum.approved
  //   // ) {
  //   //   return (
  //   //     <>
  //   //       <span style={{ color: "green" }}>
  //   //         {translate("resources.customers.related_persons.iysApproved")}
  //   //       </span>
  //   //     </>
  //   //   );
  //   // } else if (
  //   //   permission?.legalPermissionStatusId === legalPermissionStatusEnum.waiting
  //   // ) {
  //   //   return (
  //   //     <span style={{ color: "#b5b51e" }}>
  //   //       {translate("resources.customers.related_persons.iysWaiting")}
  //   //     </span>
  //   //   );
  //   // } else if (
  //   //   permission?.legalPermissionStatusId === legalPermissionStatusEnum.denied
  //   // ) {
  //   //   return (
  //   //     <span style={{ color: "red" }}>
  //   //       {translate("resources.customers.related_persons.iysDenied")}
  //   //     </span>
  //   //   );
  //   // } else {
  //   //   return (
  //   //     <span style={{ color: "orange" }}>
  //   //       {translate("resources.customers.related_persons.iysUnknown")}
  //   //     </span>
  //   //   );
  //   // }
  // };

  const getIYSDurum = (permission: any) => {
    if (
      permission?.legalPermissionStatusId === legalPermissionStatusEnum.approved
    ) {
      return (
        <>
          <span style={{ color: "green" }}>
            {translate("resources.customers.related_persons.iysApproved")}
          </span>
        </>
      );
    } else if (
      permission?.legalPermissionStatusId === legalPermissionStatusEnum.waiting
    ) {
      return (
        <span style={{ color: "#b5b51e" }}>
          {translate("resources.customers.related_persons.iysWaiting")}
        </span>
      );
    } else if (
      permission?.legalPermissionStatusId === legalPermissionStatusEnum.denied
    ) {
      return (
        <span style={{ color: "red" }}>
          {translate("resources.customers.related_persons.iysDenied")}
        </span>
      );
    } else {
      return (
        <span style={{ color: "orange" }}>
          {translate("resources.customers.related_persons.iysUnknown")}
        </span>
      );
    }
  };

  return (
    <>
      <Divider style={{ marginBottom: 15 }} />
      Kvkk Durum:{" "}
      {getKvkkDurum(
        legalPermission?.find(
          (f) =>
            f?.legalPermissionTypeId === legalPermissionTypeEnum.kvkk ||
            f?.legalPermissionTypeId === legalPermissionTypeEnum.kvkkPazarlama
        )
      )}
      <Divider style={{ marginTop: 15, marginBottom: 15 }} />
      Pazarlama (IYS) Durum:{" "}
      {getIYSDurum(
        legalPermission?.find(
          (f) =>
            f?.legalPermissionTypeId === legalPermissionTypeEnum.pazarlama ||
            f?.legalPermissionTypeId === legalPermissionTypeEnum.kvkkPazarlama
        )
      )}
      <Divider style={{ marginTop: 15 }} />
    </>
  );
};

export default LegalPermissionStatus;
